const ServiceType = {
  Recurring: 'RECURRING',
  Prepaid: 'PREPAID',
};

export default ServiceType;
